// Firebase configuration for Plaza Rural
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyBZFL3u6VExu9DNMX2faVzTvHSoCytC3_M",
    authDomain: "plaza-dev-1527808647424.firebaseapp.com",
    projectId: "plaza-dev-1527808647424",
    storageBucket: "plaza-dev-1527808647424.appspot.com",
    messagingSenderId: "409606125798",
    appId: "1:409606125798:web:f61132ea892b9821b52327",
    measurementId: "G-PYEG1T3P31"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

export default app;
